import { render, staticRenderFns } from "./profilePage.vue?vue&type=template&id=2afa9947&scoped=true&"
import script from "./profilePage.vue?vue&type=script&lang=js&"
export * from "./profilePage.vue?vue&type=script&lang=js&"
import style0 from "./profilePage.vue?vue&type=style&index=0&id=2afa9947&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa9947",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
